import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import SearchOffIcon from '@mui/icons-material/SearchOff';

export default function NotFound () {
    return(
        <Box component={"container"} sx={{textAlign:"center", padding:"4rem"}}>
            <Typography variant="h4" sx={{fontSize:"2rem", color:"#0f71ff", fontWeight:"600", letterSpacing:"1.5px"}}>Not Found <SearchOffIcon sx={{fontSize:"3rem", color:"#0f71ff"}} /></Typography>
            <Typography variant="h6" sx={{letterSpacing:"1px"}}>Didn't Find the transaction you searched for!</Typography>
        </Box>
    )
}